<app-input-wrapper
  [ngClass]="{
    'input--has-icon': icon,
    'input--error': fc?.errors && fc?.touched
  }"
  [min]="min"
  [note]="note"
  [showPassword]="showPassword"
  [isPassword]="isPassword"
  [isEmail]="isEmail"
  [type]="type"
  [label]="label"
  [for]="id"
  [fc]="fc"
  [hasPasswordValidation]="hasPasswordValidation"
  (toggleShowPassword)="showPassword = !showPassword"
>
  <app-icon *ngIf="icon" [name]="icon" class="input__icon"></app-icon>
  <input
    #input
    class="input"
    autocomplete="off"
    [attr.type]="isPassword && !showPassword ? 'password' : 'text'"
    [attr.min]="min"
    [attr.disabled]="disabled"
    [name]="getFormControlName()"
    [cdkTrapFocusAutoCapture]="focus"
    [cdkTrapFocus]="focus"
    [placeholder]="placeholder"
    [readOnly]="readonly"
    [formControl]="fc"
    [id]="id"
    (focus)="inputFocus.emit($event)"
    (blur)="inputBlur.emit($event)"
  />

  <ng-container ngProjectAs="[top-right]">
    <ng-content select="[top-right]"></ng-content>
  </ng-container>
</app-input-wrapper>
